import { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

/**
 * The checkout used to be its own screen: the agreements lived here while the
 * product, plan and quantity lived on the page before it. That was one
 * navigation for three checkboxes, in the middle of a flow whose whole point
 * is to be short - so the agreements moved onto the product page and this
 * screen went away.
 *
 * The route is kept, and redirects, because other things still point at it: a
 * returnTo saved before this change, the activation fallback, and any link
 * already in the wild. Nothing has to be hunted down for them to keep working.
 */
export default function PreorderCheckout() {
  const history = useHistory();
  const location = useLocation();
  const { slug } = useParams();

  useEffect(() => {
    history.replace({ pathname: `/preorder/${slug}`, search: location.search });
  }, [history, slug, location.search]);

  return null;
}
